export default "__VITE_ASSET__DHg6vRru__"